// Guard + rotas do Service Level. O guard só decide o que RENDERIZAR; o acesso
// é validado no backend a cada request (feature + escopo + nível).
import { ReactNode, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getMeuEscopo, MeuEscopo } from './api';
import { ServiceLevelContext } from './ServiceLevelContext';
import {hasServiceLevelPermission, ServiceLevelPermissions} from './permissions';
import ServiceLevelLayout from './layout/ServiceLevelLayout';
import Dashboard from './pages/Dashboard';
import SellerDetail from './pages/SellerDetail';
import Industria from './pages/Industria';
import PedidoDetail from './pages/PedidoDetail';
import AdminHub from './pages/AdminHub';
import AdminSlaSellers from './pages/AdminSlaSellers';
import AdminRegioesSlas from './pages/AdminRegioesSlas';

function ComPermissao({ escopo, permission, children }: {
  escopo: MeuEscopo; permission: keyof ServiceLevelPermissions; children: ReactNode
}) {
  return hasServiceLevelPermission(escopo, permission)
    ? <>{children}</> : <Navigate to="/service-level/dashboard" replace />;
}

export default function ServiceLevelRoutes() {
  const [escopo, setEscopo] = useState<MeuEscopo | null>(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    getMeuEscopo().then(setEscopo).catch(() => setErro(true));
  }, []);

  // sem acesso (403 do backend) → volta para o iexp
  if (erro) return <Navigate to="/home" replace />;
  // enquanto o escopo não chega, o overlay precisa do escopo de CSS do painel
  if (!escopo) return null; // o overlay global já indica o carregamento

  return (
    <ServiceLevelContext.Provider value={escopo}>
      <Routes>
        <Route element={<ServiceLevelLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="sellers/:id" element={<SellerDetail />} />
          <Route path="industrias/:id" element={<Industria />} />
          <Route path="pedidos/:id" element={<PedidoDetail />} />
          <Route path="admin" element={<ComPermissao escopo={escopo} permission="sync"><AdminHub /></ComPermissao>} />
          <Route path="admin/sla-sellers" element={<ComPermissao escopo={escopo} permission="sla_sellers"><AdminSlaSellers /></ComPermissao>} />
          <Route path="admin/regioes-slas" element={<ComPermissao escopo={escopo} permission="regioes_slas"><AdminRegioesSlas /></ComPermissao>} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </Routes>
    </ServiceLevelContext.Provider>
  );
}
